import { typography, utils } from "../../styles/index";

export default function PageLayout({ title, actions, children }) {
  return (
    <div id={title+"PageLayout"} style={{ ...utils.flexCol, gap: 24 }}>
      {(title || actions) && (
        <div style={utils.flexRow}>
          {title && <h1 style={typography.h2}>{title}</h1>}
          {actions}
        </div>
      )}
      {children}
    </div>
  );
}
